import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ngx-calendar-table-frequency',
    template: `<select (change)="onChange($event)">
    <option value="" disabled selected>Selecione...</option>
    <option value="days">DiÃ¡rio</option>
    <option value="month">Mensal</option>
    <option value="year">Anual</option>
</select>`
})

export class NgxCalendarTableFrequencyComponent
{
    @Output() public dataNotifier: EventEmitter<any> = new EventEmitter();

    public onChange(event)
    {
        this.dataNotifier.emit(event);
    }
}
